export default __webpack_public_path__ + "static/media/indah.994b7e72.png";